import CryptoJS, { enc } from 'crypto-js';

const getToken = () => {
  const token = decryptToken(window.localStorage?.getItem('TOKEN'));
  return token ? token : null;
};

const decryptToken = (token) => {
  if (!token) return null;
  const bytes = CryptoJS.AES.decrypt(token, process.env.REACT_APP_ENCRYPTION_KEY);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  return decrypted;
};

const saveToken = (token) => {
  const cryptedText = CryptoJS.AES.encrypt(token, process.env.REACT_APP_ENCRYPTION_KEY);
  window.localStorage?.setItem('TOKEN', cryptedText);
};

const removeToken = () => {
  window.localStorage?.removeItem('TOKEN');
};

const SchoolListUploadService = async (url, values, selectedFile, headerMapping, optionalScreenMapping) => {
  const formData = new FormData();
  formData.append('ImportType', values.ImportType);
  formData.append('FlyerHeaderTemplateId', values.FlyerHeaderTemplateId);
  formData.append('photoEventCategory', values.PhotoEventCategory);
  formData.append('PhotoEventId', values.PhotoEventId);
  formData.append('FileName', selectedFile.name);
  formData.append('Message', values.Message);
  formData.append('headerMappingFromScreen', {});
  formData.append('optionalheaderMappingFromScreen', {});
  formData.append('headerMapping', {});
  formData.append('optionalheaderMapping', {});
  formData.append('PostedFile', selectedFile);

  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    body: formData,
  };

  const response = await fetch(`${process.env.REACT_APP_APIURL_ENDPOINT}/api/` + url, requestOptions);
  let result = [];
  if (response.ok) {
    result = await response.json();
  } else {
    result = [];
  }

  return result;
};

const ProofNewVersion = async (url, values, selectedFile,fromProofId) => {
  const formData = new FormData();

  formData.append('ProofId', fromProofId);
  formData.append('EmailBody', values.emailBody);
  formData.append('ImageId', values.imageId ? values.imageId : '');
  formData.append('SendEmailFrom', values.sendEmailFrom);
  formData.append('Sendoption', values.sendoption);
  formData.append('stageId', values.stageId);
  formData.append('Subject', values.subject);
  // formData.append('FileName', selectedFile.name);
  // formData.append('PostedFile', selectedFile);

   if (selectedFile && selectedFile.length > 0) {
    selectedFile.forEach((file) => {
      // formData.append('FileName', file.name ?? '');
      formData.append('PostedFile', file.originFileObj ?? null);
    });
  } else {
    // formData.append('FileName', '');
    formData.append('PostedFile', null);
  }
  
  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    body: formData,
  };

  const response = await fetch(`${process.env.REACT_APP_APIURL_ENDPOINT}/api/` + url, requestOptions);
  let result = [];
  if (response.ok) {
    result = await response.json();
  } else {
    result = [];
  }

  return result;
};

const ImportFromLocalService = async (url, values, selectedFile) => {
  const formData = new FormData();
  formData.append('ImportCatergory', values.ImportCatergory);
  formData.append('PostedFile', selectedFile);

  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    body: formData,
  };

  const response = await fetch(`${process.env.REACT_APP_APIURL_ENDPOINT}/api/` + url, requestOptions);
  let result = [];
  if (response.ok) {
    result = await response.json();
  } else {
    result = [];
  }

  return result;
};

const MissingDataUploadService = async (url, formData) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    body: formData,
  };

  const response = await fetch(`${process.env.REACT_APP_APIURL_ENDPOINT}/api/` + url, requestOptions);
  let result = [];
  if (response.ok) {
    result = await response.json();
  } else {
    result = [];
  }
  return result;
};

const ProofDataUploadService = async (url, updatedProofValue, selectedFile) => {
  const formattedDeadline = updatedProofValue.deadline ? new Date(updatedProofValue.deadline).toISOString() : null;
  const formData = new FormData();
  if (updatedProofValue.Id) {
    formData.append('Id', updatedProofValue.Id);
  }
  if (updatedProofValue.isFileUpload && selectedFile && selectedFile.length > 0) {
    selectedFile.forEach((file) => {
      formData.append('FileName', file.name ?? '');
      formData.append('PostedFile', file.originFileObj ?? null);
    });
  } else {
    formData.append('FileName', '');
    formData.append('PostedFile', null);
  }

  formData.append('SchoolId', updatedProofValue.schoolId);
  formData.append('PhotoshootId', updatedProofValue.photoshootId);
  formData.append('ProofTitle', updatedProofValue.proofTitle);
  formData.append('ProofType', updatedProofValue.proofType);
  formData.append('Deadline', formattedDeadline);
  formData.append('Tags', updatedProofValue.tags);
  formData.append('VersionNo', updatedProofValue.versionNo);
  formData.append('ApproveIndividualFiles', updatedProofValue.approveIndividualFiles);
  formData.append('DownloadFiles', updatedProofValue.downloadFiles);
  formData.append('ViewAllComments', updatedProofValue.viewAllComments);
  formData.append('ApproveWithChanges', updatedProofValue.approveWithChanges);
  formData.append('LimitVersionVisibility', updatedProofValue.limitVersionVisibility);
  formData.append('BlockCommentingAfterDecision', updatedProofValue.blockCommentingAfterDecision);

  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    body: formData,
  };

  const response = await fetch(`${process.env.REACT_APP_APIURL_ENDPOINT}/api/` + url, requestOptions);
  let result = [];
  if (response.ok) {
    result = await response.json();
  } else {
    result = [];
  }

  return result;
};

export {
  getToken,
  decryptToken,
  saveToken,
  removeToken,
  SchoolListUploadService,
  ProofNewVersion,
  ImportFromLocalService,
  MissingDataUploadService,
  ProofDataUploadService,
};
